document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".js-toggle-measurement");
  const sizeTable = document.querySelector("#size-chart table");

  // Store original inch values and round display on load
  sizeTable.querySelectorAll("tr").forEach(row => {
    const cells = row.querySelectorAll("td");
    cells.forEach((cell, index) => {
      if (index === 0) return; // Skip label column
      const val = parseFloat(cell.textContent);
      if (!isNaN(val)) {
        const roundedInches = Math.round(val);
        cell.setAttribute("data-inches", roundedInches);
        cell.textContent = roundedInches;
      }
    });
  });

  // Default active state to Inches button
  buttons.forEach(btn => btn.setAttribute("data-active", "false"));
  if (buttons.length) {
    buttons[0].setAttribute("data-active", "true");
  }

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const selectedUnit = this.getAttribute("data-val");

      // Toggle active button
      buttons.forEach(btn => btn.setAttribute("data-active", "false"));
      this.setAttribute("data-active", "true");

      // Convert table values based on original inches
      sizeTable.querySelectorAll("tr").forEach(row => {
        const cells = row.querySelectorAll("td");
        cells.forEach((cell, index) => {
          if (index === 0) return;
          const inchVal = parseFloat(cell.getAttribute("data-inches"));
          if (isNaN(inchVal)) return;

          if (selectedUnit === "cms") {
            cell.textContent = Math.round(inchVal * 2.54);
          } else if (selectedUnit === "inches") {
            cell.textContent = Math.round(inchVal);
          }
        });
      });
    });
  });
});